import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SistemaAidRoutingModule } from './sistema-aid-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SistemaAidRoutingModule,
  ]
})
export class SistemaAidModule { }
